import type React from 'react';
import { formatPropBadge } from './scorePanelUtils';

/** Render individual direction-aware prop highlight badges */
export function PropHighlightBadges({
  propHighlights,
  legs,
  context,
}: {
  propHighlights: string[];
  legs?: Array<{ statType?: string; propType?: string; overUnder?: string | null }>;
  context?: string;
}): React.ReactElement | null {
  if (propHighlights.length === 0) return null;
  return (
    <>
      {propHighlights.map((prop) => {
        const { label, direction } = formatPropBadge(prop, legs);
        return (
          <span
            key={prop}
            className="inline-flex items-center gap-1 text-[10px] bg-purple-500 px-1.5 py-0.5 rounded text-white font-medium cursor-help"
            title={`${label}${direction ? ` ${direction}` : ''} has historically been profitable${context ? ` in ${context}` : ''}`}
          >
            {label}
            {direction && (
              <span className={direction === 'Over' ? 'text-green-300' : 'text-red-300'}>
                {direction === 'Over' ? 'O' : 'U'}
              </span>
            )}
          </span>
        );
      })}
    </>
  );
}
